import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { LinkButton } from '../../ui-kit/LinkButton/LinkButton.js';
import { calculateResult, formatValue } from './calculateResult.js';
import { callbackCurrencySelect } from './callbackCurrencySelect.js';
import { Currency } from './CurrencyProps.js';
import { renderInput } from './renderInput.js';
export const ExchangeCurrencyCalculator = JSX(({ className = '', currencyRatesBuy, currencyRatesSell, button }) => {
    const [calcState, setCalcState] = useState({
        inputSell: '',
        inputBuy: '',
        selectSell: currencyRatesBuy?.[0]?.currency?.currency || Currency.RUB,
        selectBuy: currencyRatesSell?.[0]?.currency?.currency || Currency.USD,
    });
    const handleSetCalcState = useCallback((newState) => setCalcState((oldState) => ({ ...oldState, ...newState })), []);
    return (_jsxs("div", { className: `flex flex-col gap-m pt-2xl ${className}`, children: [currencyRatesBuy && currencyRatesSell ? (_jsxs("div", { className: "grid gap-m", children: [renderInput({
                        placeholder: 'Хочу продать',
                        rates: currencyRatesSell,
                        selected: calcState.selectSell,
                        setSelected: handleSelectSell(calcState, handleSetCalcState, currencyRatesSell),
                        value: calcState.inputSell,
                        setValue: (value) => handleInputSell(handleSetCalcState, currencyRatesSell)(value, calcState.selectSell, calcState.selectBuy),
                    }), renderInput({
                        placeholder: 'Получу',
                        rates: currencyRatesBuy,
                        selected: calcState.selectBuy,
                        setSelected: handleSelectBuy(calcState, handleSetCalcState, currencyRatesBuy),
                        value: calcState.inputBuy,
                        setValue: (value) => handleInputBuy(handleSetCalcState, currencyRatesBuy)(value, calcState.selectBuy, calcState.selectSell),
                    })] })) : null, button?.text ? (_jsx(LinkButton, { text: button.text, version: button?.version, ...button })) : null] }));
});
const handleSelectSell = (calcState, setCalcState, currencyRatesSell) => (value) => {
    setCalcState({ selectSell: value });
    callbackCurrencySelect({
        value,
        oppositeValue: calcState.selectBuy,
        handleConvert: (currencyFrom = calcState.selectSell, currencyTo = calcState.selectBuy) => {
            handleInputSell(setCalcState, currencyRatesSell)(calcState.inputSell, currencyFrom, currencyTo);
        },
    });
};
const handleSelectBuy = (calcState, setCalcState, currencyRatesBuy) => (value) => {
    setCalcState({ selectBuy: value });
    callbackCurrencySelect({
        value,
        oppositeValue: calcState.selectSell,
        handleConvert: (currencyTo = calcState.selectBuy, currencyFrom = calcState.selectSell) => handleInputBuy(setCalcState, currencyRatesBuy)(calcState.inputBuy, currencyTo, currencyFrom),
    });
};
const handleInputSell = (setCalcState, currencyRatesSell) => (value, currencyFrom, currencyTo) => {
    setCalcState({ inputSell: formatValue(value), selectBuy: currencyTo });
    const rate = currencyRatesSell.find((_) => _.currency?.currency === currencyTo)?.buyExchangeRate ||
        currencyRatesSell.find((_) => _.currency?.currency === currencyFrom)?.buyExchangeRate;
    if (rate) {
        setCalcState({
            inputBuy: String(calculateResult(value, rate, currencyFrom === Currency.RUB) || ''),
        });
    }
};
const handleInputBuy = (setCalcState, currencyRatesBuy) => (value, currencyTo, currencyFrom) => {
    setCalcState({ inputBuy: formatValue(value), selectSell: currencyFrom });
    const rate = currencyRatesBuy.find((_) => _.currency?.currency === currencyFrom)?.saleExchangeRate ||
        currencyRatesBuy.find((_) => _.currency?.currency === currencyTo)?.saleExchangeRate;
    if (rate) {
        setCalcState({
            inputSell: String(calculateResult(value, rate, currencyTo === Currency.RUB) || ''),
        });
    }
};
//# sourceMappingURL=ExchangeCurrencyCalculator.js.map